import * as React from "react"

const SvgArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16.179 13.292H5a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713q0-.424.288-.712A.97.97 0 0 1 5 11.292h11.18l-4.902-4.899a.92.92 0 0 1-.287-.7q.012-.4.312-.7.3-.275.7-.287t.7.288l6.603 6.598q.15.15.212.325.063.176.063.375c0 .199-.02.258-.063.375a.9.9 0 0 1-.212.325l-6.602 6.599a.93.93 0 0 1-.688.275 1.02 1.02 0 0 1-.713-.275q-.3-.3-.3-.713 0-.412.3-.712z" />
  </svg>
)
export default SvgArrowRight
